import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { exportAllGuestsExcelUrl } from "@/business/events/infrastructure/constants/urls";

export const exportAllGuestsExcel = {
  async execute(): Promise<string> {
    return getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(exportAllGuestsExcelUrl);
  },
};
